import React, { useState, useEffect, useContext, useCallback } from "react";
import PageTitle from "../../Components/PageTitle";
import axios from "axios";
import Swal from "sweetalert2";
import { ConfigContext } from "../../Context/ConfigContext";
import { ContentLoader, NoRecords } from "../../Components/Shimmer";
import Select from "react-select";
import { Link, NavLink, useNavigate, useParams } from "react-router-dom";
import { type } from "@testing-library/user-event/dist/type";
import { formatDate } from "../../Components/GlobalFunctions";
import { handleDownloadOptions } from "../../Components/ExportData";

const ProjectRequest = ({ }) => {

    const { apiURL, apiHeaderJson, apiHeaderFile, user_profile_id } = useContext(ConfigContext);
    const [consultantRequest, setConsultantRequest] = useState([]);
    const [rows, setRows] = useState([]);
    const [ItemRows, setItemRows] = useState([]);
    const [next, setNext] = useState(false);
    const [prev, setPrev] = useState(false);
    const [page, setPage] = useState(1);
    const [limit] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [loadingList, setLoadingList] = useState(true);
    const [keyword, setKeyword] = useState("");
    const [reload, setReload] = useState(false);
    const [selectedOptions, setSelectedOptions] = useState(null);
    const [requestedInfo, setRequestedInfo] = useState({});
    const [selectOption, setSelectOption] = useState(null);
    const [status, setStatus] = useState(null);
    const [itemRemark, setItemRemark] = useState("");
    const [comment, setComment] = useState("");
    const [consultantInfo, setConsultantInfo] = useState([]);
    const [attachments, setAttachments] = useState([])
    const [selectedProjectId, setSelectedProjectId] = useState(null);
    const [selectedInspectionId, setSelectedInspectionId] = useState(null);
    const [projectRequestId, setProjectRequestId] = useState(null)
    const [contractorID, setContractorID] = useState(null)
    const [showModal, setShowModal] = useState(false);
    const [selectedAction, setSelectedAction] = useState('');
    const [consultantData, setConsultantData] = useState([]);
    const [consultantId, setConsultantId] = useState(0);
    const [projectInspectionID, setProjectInspectionID] = useState(null)
    const [inspectionFormData, setInspectionFormData] = useState([]);
    const [inspectionFormID, setinspectionFormID] = useState(null);
    const [submittalDescription, setSubmittalDescription] = useState("");
    const [requiredInspection, setRequiredInspection] = useState(null);

    const navigate = useNavigate()

    const { project_id, } = useParams();

    const options = [
        { value: "pending", label: "Pending" },
        { value: "approved", label: "Approved" },
        { value: "rejected", label: "Rejected" },
    ];

    // Add form selection handler
    const handleFormSelect = (selectedOption) => {
        setinspectionFormID(selectedOption ? selectedOption.value : null);
    };

    // Add inspection form fetching function
    const getInspectionForm = async () => {
        try {
            const headers = apiHeaderJson;
            const response = await axios.get(`${apiURL}api/inspections/GetInspections`, { headers });
            const { data } = response.data;

            setInspectionFormData(
                data
                    // .filter(row => row.type_of_submittal === submittalDescription)
                    .map(row => ({
                        value: row.inspection_id,
                        label: row.inspection_title
                    }))
            );
        } catch (error) {
            console.log(error);
        }
    };

    const getProjectConsultant = async () => {
        try {
            const response = await axios.get(`${apiURL}api/project-consultants/project/${project_id}`);
            const { data, success } = response.data;

            if (success === true) {
                setConsultantData(
                    data.map((row) => ({
                        value: row.consultant_id,
                        label: row.profile_name
                    }))
                );
            }
        } catch (error) {
            console.log(error);
        }
    };

    const getAllRequests = async () => {
        try {

            const headers = apiHeaderJson;
            const response = await axios.get(`${apiURL}api/requests/GetAllRequestsForConsultant`, { params: { consultant_id: user_profile_id, page, limit }, headers })
            const { data, success, next, prev, page: currentPage, total_records, total_pages } = response.data;
            if (success === true) {

                setConsultantRequest(data.filter((row) => Number(row?.project_id) === Number(project_id)))
                setProjectInspectionID(data.project_inspection_id || null)

                setNext(next);
                setPrev(prev);
                setPage(currentPage);
                setTotalRecords(total_records);
                setTotalPages(total_pages);
            }
        } catch (error) {
            console.log(error);

        }
    }

    const GetInfo = (row) => {
        const headers = apiHeaderJson;
        setSelectedProjectId(row?.project_id || null);
        setSelectedInspectionId(row?.inspection_id || null);
        setProjectRequestId(row?.project_request_id || null)
        setContractorID(row?.contractor_id || null)
        setSubmittalDescription(row?.submittal_description || "")
        setRequiredInspection(row?.required_inspection ?? 0);

        axios
            .get(`${apiURL}api/requests/GetProjectRequestInfo?project_request_id=${row?.project_request_id}`, {
                headers,
            })
            .then((response) => {
                const { data, success } = response.data;
                if (success) {
                    setRequestedInfo(data.info)
                    setConsultantInfo(data.consultants)
                    setAttachments(data.attachments)
                }
            });
    };

    const GetList = async () => {
        try {
            const headers = apiHeaderJson;
            const response = await axios.get(
                `${apiURL}api/consultants/Get-Request-Items`,
                {
                    params: { consultant_id: user_profile_id },
                    headers,
                }
            );
            const data = response.data;

            if (data.success) {
                setRows(data.data);
                setNext(data.next);
                setPrev(data.prev);
                setPage(data.page);
                setTotalRecords(data.total_records);
                setTotalPages(data.total_pages);
                setReload(false);
            }
            setLoadingList(false);
        } catch (error) {
            console.log(error);
        }
    };



    const handlePrev = () => {
        if (prev) {
            setPage((prevPage) => prevPage - 1);
        }
    };

    const handleNext = () => {
        if (next) {
            setPage((prevPage) => prevPage + 1);
        }
    };

    const handleChange = (e) => {
        setPage(parseInt(e.target.value, 10));
    };

    const resetForm = () => {
        setItemRows("");
    };

    const handleClear = () => {
        setKeyword("");
        setReload(true);
    };

    const Labels = (status) => {
        if (status === 0) {
            return "Pending";
        } else if (status === 1) {
            return "Approved";
        } else if (status === 2) {
            return "Revise";
        }
        else if (status === 3) {
            return "Rejected";
        }
        else if (status === 4) {
            return "In-Clearence";
        }

    };
    const Classes = (status) => {
        if (status === 0) {
            return "badge bg-warning-subtle text-warning";
        } else if (status === 1) {
            return "badge bg-success-subtle text-success";
        } else if (status === 2) {
            return "badge bg-info-subtle text-info";
        } else if (status === 3) {
            return "badge bg-danger-subtle text-danger";
        } else if (status === 4) {
            return "badge bg-secondary-subtle text-secondary";
        }
    };

    const handleSelectStatus = (selectedOption) => {
        setSelectOption(selectedOption ? selectedOption.value : "");
    };
    const ClearModal = () => {
        setComment('')
        setRequestedInfo({})
    }
    const typeText = (type) => {
        if (type === 1) {
            return 'Approve'
        }
        if (type === 2) {
            return "Reject"
        }
        if (type === 3) {
            return "Revise and Resubmit"
        }
    }

    const handleActionSubmit = async () => {
        const statusMap = {
            "Direct Approve": '1',
            "Reject": '3'
            // Note: Revise is handled separately below
        };

        if (!selectedAction) {
            Swal.fire({
                icon: 'warning',
                title: 'Please select an action',
                timer: 1500,
                showConfirmButton: false
            });
            return;
        }

        const headers = apiHeaderJson;

        try {
            let response;

            if (selectedAction === "Clearance Required") {
                if (!consultantId) {
                    Swal.fire({
                        icon: 'warning',
                        title: 'Please select a consultant for Clearance Required',
                        timer: 1500,
                        showConfirmButton: false
                    });
                    return;
                }

                // Call AssignForClearance API
                const formData = new FormData();
                formData.append("project_request_id", projectRequestId);
                formData.append("project_id", project_id);
                formData.append("consultant_id", consultantId);
                formData.append("assigned_by", user_profile_id);

                response = await axios.post(
                    `${apiURL}api/requests/AssignForClearance`,
                    formData,
                    { headers }
                );

            } else if (selectedAction === "Revise") {
                if (!comment?.trim()) {
                    Swal.fire({
                        icon: 'warning',
                        title: 'Please enter a remark for revision',
                        timer: 1500,
                        showConfirmButton: false
                    });
                    return;
                }
                const formData = new FormData();
                formData.append("project_request_id", projectRequestId);
                formData.append("remark", comment);

                response = await axios.post(
                    `${apiURL}api/requests/AskForRevision`,
                    formData,
                    { headers }
                );

            } else {
                // Call existing status API for Direct Approve & Reject
                const body = {
                    project_request_id: projectRequestId,
                    consultant_id: user_profile_id,
                    consultant_status: statusMap[selectedAction],
                    consultant_remark: comment
                };

                response = await axios.patch(
                    `${apiURL}api/project-items/status`,
                    body,
                    { headers }
                );
            }

            const { success, message } = response.data;

            await Swal.fire({
                icon: success ? 'success' : "error",
                title: message,
                showConfirmButton: false,
                timer: 1500
            });

            if (success) {
                setShowModal(false);
                clearActionModal();
                getAllRequests();
            }
        } catch (error) {
            console.error(error);
            Swal.fire({
                icon: 'error',
                title: 'Error taking action',
                showConfirmButton: false,
                timer: 1500
            });
        }
    };

    const handleModalCloseOrCancel = () => {
        setShowModal(false);
        clearActionModal();
    }


    const handleConsultantChange = (selectedOption) => {
        setConsultantId(selectedOption ? selectedOption.value : null);
    }

    const handleDownload = (downloadType) => {
        const endpoint = `api/requests/GetAllRequestsForConsultant`;
        const params = {
            consultant_id: user_profile_id
        };

        const columns = [
            { header: "Project Name", width: 35 },
            { header: "Item Name", width: 26 },
            { header: "Quantity", width: 20 },
            { header: " Price(QAR)", width: 20 },
            { header: " Status", width: 25 },
        ];

        const mapRow = (data) => ({
            "Project Name": data?.project_title ?? "-",
            "Item Name": data?.item_name ?? "-",
            "Quantity": data?.pi_item_qty ?? "-",
            " Price(QAR)": data?.pi_item_price ?? "-",
            " Status": data?.consultant_given_status ? Labels(data.consultant_given_status) : Labels(data.request_status) ?? "-",
        });

        handleDownloadOptions(endpoint, params, columns, mapRow, downloadType, apiURL, apiHeaderJson);
    };
    const clearActionModal = () => {
        setSelectedAction('');
        setComment('');
        setConsultantId(0);
    }


    useEffect(() => {
        GetList();
        getAllRequests()
    }, [page, limit]);

    useEffect(() => {
        // getItemsList();
        reload && GetList();
    }, [reload]);
    useEffect(() => {
        project_id && getProjectConsultant()
    }, [project_id])

    useEffect(() => {
        getInspectionForm();
    }, [])

    return (

        <div className="col-xxl-12">
            <div className="card">
                {loadingList ? (<ContentLoader />) :
                    <div className="card-body">
                        <div className="card-header d-flex align-items-center mb-4">
                            <h5 className="card-title flex-grow-1 mb-0">Project Request </h5>

                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="table-responsive">
                                    <table className="table table-borderless align-middle mb-0">
                                        <thead className="table-light">
                                            <tr>
                                                <th className="text-center" width="28%">
                                                    Project Name
                                                </th>
                                                <th className="text-center" width="25%">
                                                    Item Name
                                                </th>
                                                <th className="text-center" width="15%">
                                                    Quantity
                                                </th>
                                                <th className="text-center" width="15%">
                                                    Price(QAR)
                                                </th>
                                                <th className="text-center" width="10%">
                                                    Status
                                                </th>
                                                <th className="text-center" width="14%">
                                                    Action
                                                </th>
                                            </tr>
                                        </thead>
                                        {consultantRequest.length !== 0 ? (
                                            <>
                                                <tbody>
                                                    {
                                                        consultantRequest.map((row) => (
                                                            <tr key={row.category_id}>
                                                                <td className="text-center">
                                                                    <NavLink to={`/ProjectProfile/${row?.project_id}`}>{row?.project_title}</NavLink>
                                                                </td>
                                                                <td className="text-center">
                                                                    {row?.item_name ?? "-"}
                                                                </td>
                                                                <td className="text-center">
                                                                    {row?.pi_item_qty ?? "-"}
                                                                </td>
                                                                <td className="text-center">
                                                                    {row?.pi_item_price ?? "-"}
                                                                </td>
                                                                {row?.consultant_given_status ?
                                                                    <td className="text-center">
                                                                        <span className={Classes(row?.consultant_given_status)}>
                                                                            {Labels(row.consultant_given_status)}
                                                                        </span>
                                                                    </td>
                                                                    : <td className="text-center">
                                                                        <span className={Classes(row.request_status)}>
                                                                            {Labels(row.request_status)}
                                                                        </span>
                                                                    </td>}
                                                                <td className="d-flex justify-content-around">


                                                                    {row.request_status === 0 &&
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-link text-success fs-18 p-0"
                                                                            data-bs-toggle="modal"
                                                                            data-bs-target="#myModal"
                                                                            onClick={() => GetInfo(row)}
                                                                        >
                                                                            <i className=" ri-edit-line" />
                                                                        </button>}

                                                                    <Link to={`/PreviewStatus/${row?.project_request_id}`}>
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-link text-info fs-18 p-0"

                                                                        >
                                                                            <i className=" ri-eye-line" />
                                                                        </button>
                                                                    </Link>



                                                                </td>
                                                            </tr>
                                                        ))}
                                                </tbody>
                                                <tfoot className="table-light">
                                                    <tr>
                                                        <th colSpan={10}>
                                                            <div className="d-flex justify-content-between align-items-center">
                                                                {/* PREV */}
                                                                <button
                                                                    className="btn btn-warning btn-label"
                                                                    onClick={() => prev && setPage(page - 1)}
                                                                    disabled={!prev}
                                                                >
                                                                    <i className="ri-arrow-left-line label-icon me-2"></i> Previous
                                                                </button>

                                                                {/* Info */}
                                                                <small>
                                                                    Total Records: {totalRecords} | Total Pages: {totalPages} |
                                                                    Current Page: {page}
                                                                </small>

                                                                {/* Page Select */}
                                                                <select
                                                                    className="form-select w-auto"
                                                                    value={page}
                                                                    onChange={(e) => setPage(Number(e.target.value))}
                                                                >
                                                                    {Array.from({ length: totalPages }, (_, i) => (
                                                                        <option key={i + 1} value={i + 1}>
                                                                            {i + 1}
                                                                        </option>
                                                                    ))}
                                                                </select>

                                                                {/* NEXT */}
                                                                <button
                                                                    className="btn btn-primary btn-label"
                                                                    onClick={() => next && setPage(page + 1)}
                                                                    disabled={!next}
                                                                >
                                                                    Next <i className="ri-arrow-right-line label-icon ms-2"></i>
                                                                </button>
                                                            </div>
                                                        </th>
                                                    </tr>
                                                </tfoot>
                                            </>
                                        ) : (
                                            <tbody>
                                                <tr>
                                                    <td colSpan="8">
                                                        <NoRecords />
                                                    </td>
                                                </tr>
                                            </tbody>
                                        )}
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                }

            </div>
            <>
                <div
                    id="myModal"
                    className="modal fade"
                    tabIndex={-1}
                    aria-labelledby="myModalLabel"
                    aria-hidden="true"
                    style={{ display: "none" }}
                >
                    <form>
                        <div className="modal-dialog modal-dialog-centered modal-lg">
                            <div className="modal-content">
                                {/* Modal Header */}
                                <div
                                    className="modal-header d-flex justify-content-between align-items-center"
                                    style={{ background: "#000000", padding: "15px" }}
                                >
                                    <div className="w-100">
                                        <div className="row">
                                            <div className="col-md-4">
                                                <h5 className="mb-0 text-white">Title: {requestedInfo?.project_title ?? '-'}</h5>
                                            </div>
                                            <div className="col-md-4">
                                                <h5 className="mb-0 text-white">Ref.#: {requestedInfo?.project_request_id ?? '0'}</h5>
                                            </div>
                                            <div className="col-md-4">
                                                <h5 className="mb-0 text-white">Rev # : {requestedInfo?.request_revision_count ?? '0'}</h5>
                                            </div>
                                        </div>
                                    </div>
                                    <button
                                        type="button"
                                        onClick={() => ClearModal()}
                                        id="close-create-modal"
                                        className="btn-close"
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                        style={{ filter: "invert(1)" }} // Keeps close button visible
                                    ></button>
                                </div>

                                {/* Modal Body */}
                                <div className="modal-body">

                                    {/* Section: Item Details */}
                                    <div className="mb-3 p-3 border rounded bg-white ">
                                        <h6 className="text-primary mb-2">Item Details</h6>
                                        <div className="row">
                                            <div className="col-md-3">
                                                <strong>Item Name:</strong> {requestedInfo?.item_name}
                                            </div>
                                            <div className="col-md-9">
                                                <strong>Type of Submittal:</strong> {requestedInfo?.submittal_description}
                                            </div>
                                            <div className="col-md-12 mt-3">
                                                <strong>Brief Description:</strong> {requestedInfo?.request_brief_description}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Section: Form Selection */}
                                    {requiredInspection === 0 ? <></> :
                                        <div className="mb-3 p-3 border rounded bg-white">
                                            <h6 className="text-primary mb-2">Select Inspection Form</h6>
                                            <Select
                                                onChange={handleFormSelect}
                                                options={inspectionFormData}
                                                placeholder="Select Form"
                                                value={inspectionFormID ? inspectionFormData.find(opt => opt.value === inspectionFormID) : null}
                                            />
                                        </div>}

                                    {/* Section: Uploaded Files */}
                                    <div className="mb-3 p-3 border rounded bg-light">
                                        <h6 className="text-primary mb-2">Uploaded Files</h6>
                                        {attachments.length > 0 ? (
                                            <div className="d-flex flex-wrap gap-3">
                                                {attachments.map((file, index) => {
                                                    const fileUrl = file.attachment_path.replace(/\\/g, '');
                                                    const lowerUrl = fileUrl.toLowerCase();
                                                    const isPdf = lowerUrl.endsWith('.pdf');
                                                    const isImage = /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(lowerUrl);

                                                    return (
                                                        <a
                                                            key={index}
                                                            href={fileUrl}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="text-decoration-none"
                                                            style={{ width: '100px' }}
                                                        >
                                                            <div className="p-2 bg-white rounded  d-flex flex-column align-items-center border">
                                                                <i
                                                                    className={`ri-${isPdf
                                                                        ? 'file-pdf-fill text-danger'
                                                                        : isImage
                                                                            ? 'image-fill text-primary'
                                                                            : 'file-fill text-secondary'
                                                                        } fs-1 mb-1`}
                                                                ></i>
                                                                <small className="text-truncate text-center text-muted" style={{ maxWidth: '80px' }}>
                                                                    {isPdf ? 'PDF Document' : isImage ? 'Image File' : 'Other File'}
                                                                </small>
                                                            </div>
                                                        </a>
                                                    );
                                                })}
                                            </div>
                                        ) : (
                                            <p className="text-muted mb-0">No File Uploaded</p>
                                        )}
                                    </div>

                                    {/* Section: Contractor Details */}
                                    <div className="mb-3 p-3 border rounded bg-white ">
                                        <h6 className="text-primary mb-2">Contractor Details</h6>
                                        <div className="row">
                                            <div className="col-md-4">

                                                <p><strong>Name:</strong> {requestedInfo?.profile_name}</p>

                                            </div>
                                            <div className="col-md-4">
                                                <p><strong>Email:</strong> {requestedInfo?.profile_email}</p>

                                            </div>
                                            <div className="col-md-4">
                                                <p><strong>Contact Number:</strong> {requestedInfo?.profile_contact_number}</p>
                                            </div>
                                        </div>
                                    </div>



                                    {/* Submit Button */}
                                    <div className="d-flex justify-content-end align-items-end mt-3">
                                        {requiredInspection === 1 ? (
                                            // Show Complete Inspection button
                                            <NavLink to={`/FillForm/${inspectionFormID}/${selectedProjectId}/${projectRequestId}/${contractorID}`}>
                                                <button
                                                    disabled={projectInspectionID || !inspectionFormID}
                                                    type="button"
                                                    onClick={() => { document.getElementById("close-create-modal")?.click(); }}
                                                    className="btn btn-success waves-effect waves-light"
                                                >
                                                    Complete Inspection
                                                </button>
                                            </NavLink>
                                        ) : (
                                            // Show Take Action button
                                            <button
                                                type="button"
                                                className="btn btn-info waves-effect waves-light"
                                                onClick={() => {
                                                    setShowModal(true);
                                                    document.getElementById("close-create-modal")?.click();
                                                }}
                                            >
                                                Take Action
                                            </button>
                                        )}
                                    </div>

                                </div>

                            </div>
                        </div>
                    </form>
                </div>


                {/* /.modal */}
            </>
            {showModal && (
                <div className="modal show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Take Action</h5>
                                <button type="button" className="btn-close" onClick={handleModalCloseOrCancel}></button>
                            </div>
                            <div className="modal-body">
                                <div className="d-flex flex-wrap gap-2 justify-content-between mb-3">
                                    {['Direct Approve', 'Revise', 'Reject', 'Clearance Required'].map(action => (
                                        <button
                                            key={action}
                                            className={`btn ${selectedAction === action ? 'btn-primary' : 'btn-outline-primary'} flex-fill`}
                                            onClick={() => setSelectedAction(action)}
                                            style={{ minWidth: '140px' }}
                                        >
                                            {action}
                                        </button>
                                    ))}
                                </div>

                                {selectedAction === 'Clearance Required' && (
                                    <div className="mb-3">
                                        <Select
                                            options={consultantData}
                                            onChange={handleConsultantChange}
                                            placeholder="Please select consultant"
                                            value={consultantId ? consultantData.find(opt => opt.value === consultantId) : null}
                                        />
                                    </div>
                                )}

                                <textarea
                                    className="form-control"
                                    placeholder="Comment / Remark"
                                    rows="4"
                                    value={comment}
                                    onChange={(e) => setComment(e.target.value)}
                                />
                            </div>

                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-warning"
                                    disabled={!selectedAction && !comment}
                                    onClick={() => {
                                        setSelectedAction('');
                                        setComment('');
                                        setConsultantId(0);
                                    }}
                                >
                                    Clear
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={handleModalCloseOrCancel}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={handleActionSubmit}
                                >
                                    Submit Action
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            )}
        </div>

    );
};

export default ProjectRequest;